<template>
    <div class="mx-2 pt-5 d-flex flex-wrap align-center">
        <date-picker label="Fecha inicio" @dateSelected="onStartDateSelected" class="mx-2 my-1" />
        <date-picker label="Fecha fin" @dateSelected="onEndDateSelected" class="mx-2 my-1" />
        <v-btn class="btn-save" style="z-index: 100;" @click="autoFilter">Buscar Movimientos</v-btn>
        <slot :startDate="startDate" :endDate="endDate"></slot>
        <alert
            v-model="alert.show"
            v-bind="{ ...alert }"
        ></alert>
    </div>
    
</template>

<script>
import DatePicker from '@/components/DatePicker'
import { convertDateFormat } from '@/helpers/formatDate'
import moment from 'moment';

export default {
    name: 'DateFilterNotSync',

    components: { DatePicker },

    props: {
        dataToFilter: {
            type: Array,
        },
        componentToFilter: {
            type: String,
            default: 'History'
        },
        filterEndpoint: {
            type: Function
        },
        isFilteredByOutsource: {
            type: Boolean
        },
        search:{
            type: Object,
            default: () => ({})
        }
    },

    mounted() {
        this.saveData()
        // Emitir reset-data para cargar todas las facturas inicialmente
        this.$emit('reset-data')
    },

    data() {
        return {
            startDate: null,
            endDate: null,
            oldData: [],
            sourceFormat: "dd/mm/yyyy",
            targetFormat: "yyyy-mm-dd",
            alert: {
                type: "success",
                show: false,
                message: "",
            },
        }
    },

    methods: {
        onStartDateSelected(param) {
            this.startDate = param;
            this.$emit('setStartDate', param);
        },
        
        onEndDateSelected(param) {
            this.endDate = param;
            this.$emit('setEndDate', param);
        },

        async autoFilter() {
            // Solo filtrar si ambas fechas están seleccionadas
            if (this.startDate && this.endDate) {
                await this.filterData();
            }
        },

        async filterData() {
            await this.$nextTick();
            this.$emit('datesSelected', { start: this.startDate, end: this.endDate })
            try {
                const { startDate, endDate } = this.setDateFormat()

                this.resetDateData()
                if (!this.isFilteredByOutsource) {
                    const filteredData = await this.filterByEndpoint({ startDate, endDate })
                    this.$emit('filtered-data', filteredData)
                } else {
                    this.filterByComponent()
                }
            } catch (error) {
                this.$emit('filter-error', this.getFilterErrorMessage(error))
            } finally {
                this.$emit('filtered-loading', false)
            }
        },
        
        resetFilter() {
            this.$emit('filtered-data', this.oldData)
            this.$emit('reset-data')
        },
        saveData() {
            this.oldData = [...this.dataToFilter]
        },
        setDateFormat() {
            return {
                 startDate: new Date(convertDateFormat(this.startDate, this.sourceFormat, this.targetFormat)),
                 endDate: new Date(convertDateFormat(this.endDate, this.sourceFormat, this.targetFormat)) 
            }
        },
        resetDateData() {
            this.dataToFilter = [...this.oldData]
        },
        filterByComponent() {
            try {
                if( this.componentToFilter == 'HistoryR2' ) {
                    moment.locale( 'es_SV' );
                    
                    const filteredData =
                        [...this.dataToFilter].filter((data) => {
                            const dataDate = moment( data.InvoiceDate )
                            const startFormatted = moment( this.startDate, 'DD/MM/YYYY' )
                            const endFormatted = moment( this.endDate, 'DD/MM/YYYY' )
                            const isInRange = dataDate.isBetween( startFormatted, endFormatted, 'day', '[]' );
                            return isInRange
                        });
                    
                    this.$emit('filtered-data', { data: filteredData })
                } else if (this.componentToFilter == 'History') {
                    const filteredData =
                        [...this.dataToFilter].filter((data) => {
                            const dataDate = new Date(convertDateFormat(data.InvoiceDate, this.sourceFormat, this.targetFormat))
                            const isInRange = dataDate >= this.startDate && dataDate <= this.endDate
                            console.log( isInRange, dataDate );
                            return isInRange
                        })
                    this.$emit('filtered-data', filteredData)
                } else if (this.componentToFilter == 'PurchareOrdersList') {
                    const filteredData =
                        [...this.dataToFilter].filter((data) => {
                            const dataDate = new Date(convertDateFormat(data.PurchaseOrderDate, this.sourceFormat, this.targetFormat))
                            const isInRange = dataDate >= this.startDate && dataDate <= this.endDate
                            return isInRange
                        }
                    )
                    this.$emit('filtered-data', filteredData)
                }
            } catch (error) {
                console.log( error );
            }
        },
        async filterByEndpoint({ startDate, endDate }){
            this.$emit('filtered-loading', true)
            try {
                return await this.filterEndpoint({ start: startDate, end: endDate, ...this.search});
            } finally {
                this.$emit('filtered-loading', false)
            }
        },
        getFilterErrorMessage(error) {
            const baseMessage = 'No se pudo consultar el detalle por un problema de conexión. Verifique su internet e intente nuevamente.';
            const errorMessage = String(error?.message || '').toLowerCase();
            const isConnectionError =
                !error?.response
                || error?.code === 'ERR_NETWORK'
                || errorMessage.includes('network')
                || errorMessage.includes('failed to fetch')
                || errorMessage.includes('timeout');

            if (isConnectionError) {
                return baseMessage;
            }

            return error?.response?.data?.message || error?.message || 'No se pudo consultar el detalle.';
        }
    }
}
</script>

<style scoped>
.btn-add {
    background-color: #4690DB !important;
    color: white;
}

.btn-filter {
    background-color: #f29d35 !important;
    color: white;
}

.background {
    background: white !important;
    color: white;
}
</style>
